import { useAtom } from 'jotai';
import { atomWithQuery } from 'jotai-tanstack-query';
import { paymentMethodsCacheKey, queryFnFactory } from '@syf-api-library/payment-methods';
import { apiConfigAtom } from './accountActivity';
export const paymentMethodsAtom = atomWithQuery((get) => {
    const apiConfig = get(apiConfigAtom);
    return {
        queryKey: paymentMethodsCacheKey(apiConfig.keyProps),
        queryFn: queryFnFactory(apiConfig.config, apiConfig.keyProps),
        queryOptions: Object.assign({}, apiConfig.queryOptions)
    };
});
export const usePaymentMethods = () => {
    return useAtom(paymentMethodsAtom);
};
